function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.5h30v21H0V4.5Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55,15l12.45,7.95,12.45-7.95-12.45-7.95L2.55,15Z",
    style: {
      fill: "#fedf00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5.25,
    style: {
      fill: "#002776"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 5.25,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.197,12.892c-.112.255-.192.524-.263.798.672-.117,1.36-.19,2.065-.19,3.071,0,5.864,1.164,7.987,3.062.085-.272.15-.551.19-.84-2.214-1.854-5.064-2.972-8.177-2.972-.613,0-1.212.058-1.802.142Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M10.522,13.466c.123-.015.21-.138.193-.276-.016-.137-.13-.236-.254-.22s-.21.138-.193.276c.017.136.131.236.254.22M10.51,13.373c.073-.009.123-.086.112-.172s-.078-.149-.151-.139c-.073.009-.123.086-.112.172s.079.149.151.139",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M10.93,13.42l.092-.006-.013-.186.2-.014c.086-.006.152-.081.146-.168-.006-.086-.081-.152-.168-.146l-.285.019.029.5ZM11.002,13.136l.193-.013c.036-.002.063-.033.059-.069-.002-.036-.033-.062-.069-.059l-.193.013.009.128Z",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.354,13.391c-.005-.071-.016-.228-.123-.22l-.135.009c.157-.011.168.146.172.217",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M11.563,13.38l.236-.004c.118-.002.212-.099.21-.218v-.072c-.003-.118-.1-.212-.219-.21l-.236.004.009.5ZM11.654,13.286l.135-.002c.075-.001.134-.064.133-.138v-.043c-.002-.075-.065-.134-.139-.133l-.135.002.006.315Z",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M12.198,13.374l.45.015.003-.093-.364-.012.004-.128.286.01.003-.086-.286-.01.003-.099.342.012.003-.093-.428-.015-.016.5Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M12.832,13.401l.085.007.03-.341.07.351.078.007.129-.333-.03.341.085.007.044-.498-.124-.011-.129.333-.07-.351-.124-.011-.044.499Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M13.868,13.519l.37.064.014-.084-.285-.049.019-.113.233.04.014-.084-.233-.04.013-.078.277.047.014-.084-.361-.061-.077.443Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c1",
    "data-name": "c",
    d: "M14.818,13.704l.09.024.046-.179.194.05c.084.022.17-.029.192-.113s-.029-.17-.113-.192l-.277-.072-.132.482ZM14.977,13.458l.187.048c.035.009.07-.011.078-.046.009-.035-.011-.07-.046-.078l-.187-.048-.032.124Z",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c2",
    "data-name": "c",
    d: "M15.432,13.868l.088.028.055-.177.191.06c.083.026.171-.019.197-.102s-.019-.171-.103-.197l-.273-.086-.156.475ZM15.604,13.631l.183.058c.034.01.07-.008.081-.042.01-.034-.008-.07-.042-.081l-.183-.058-.039.123Z",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.836,13.997c.022-.068.069-.218-.034-.25l-.129-.041c.15.047.103.197.081.265",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M16.246,14.143c.117.043.25-.026.298-.156.048-.129-.007-.27-.123-.313s-.25.026-.298.156c-.049.129.006.269.123.313M16.278,14.056c.069.026.149-.019.178-.1.031-.081,0-.168-.069-.194s-.149.019-.178.1c-.03.081.001.168.069.194",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.629,14.291l.2-.458.413.179-.2.458-.413-.179ZM16.969,14.072l-.034.079.206.09.034-.079-.206-.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2",
    "data-name": "b",
    d: "M16.835,14.381c.114.049.251-.013.306-.139s.007-.27-.107-.319-.251.013-.306.139-.007.269.107.319M16.872,14.296c.067.029.15-.012.183-.091.035-.08.008-.168-.058-.197-.067-.029-.15.012-.183.091s-.008.167.058.197",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.967,14.166l.173.076-.029.066-.173-.076.029-.066Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.076,14.213l.066.029-.099.23-.066-.029.099-.23Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "c3",
    "data-name": "c",
    d: "M17.209,14.549l.083.041.083-.166.179.089c.078.039.172.007.211-.071s.007-.172-.071-.211l-.255-.127-.231.445ZM17.416,14.341l.172.086c.032.015.071.003.086-.029s.003-.071-.029-.086l-.172-.086-.057.115Z",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.589,14.739c.032-.064.103-.205.006-.252l-.121-.06c.14.07.071.211.039.275",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "j1",
    "data-name": "j",
    d: "M17.775,14.836l.392.221.046-.081-.317-.179.064-.112.249.14.042-.075-.249-.14.049-.087.298.169.046-.081-.373-.211-.247.436Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M18.505,15.081c-.027.042,0,.089.06.127.06.038.101.037.119.01.054-.086-.261-.211-.164-.361.084-.128.228-.029.282.006s.141.124.074.227l-.092-.058c.029-.045-.003-.088-.051-.119-.047-.03-.085-.043-.113,0-.046.07.263.202.168.351-.07.11-.192.061-.274.01-.07-.044-.173-.149-.106-.253l.096.06Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "n1",
    "data-name": "n",
    d: "M19.041,15.436c-.029.041-.004.089.054.13.058.041.099.042.118.016.059-.083-.25-.224-.145-.369.09-.124.229-.016.281.021s.134.131.062.231l-.089-.064c.031-.044.002-.088-.045-.122-.045-.032-.082-.048-.113-.005-.05.068.252.215.15.359-.076.107-.195.052-.274-.004-.067-.048-.165-.157-.092-.258l.093.066Z",
    style: {
      fill: "#009b3a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b3",
    "data-name": "b",
    d: "M19.548,16.011c.097.078.246.052.332-.055s.077-.258-.021-.336c-.097-.077-.246-.052-.332.055s-.077.259.021.336M19.605,15.938c.057.045.148.027.201-.041.054-.068.051-.16-.005-.205-.057-.045-.148-.028-.201.041-.054.068-.051.16.005.205",
    style: {
      fill: "#009b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.765 13.987 10.714 13.833 10.664 13.987 10.5 13.987 10.633 14.084 10.582 14.239 10.714 14.144 10.847 14.239 10.796 14.083 10.928 13.987 10.765 13.987",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.229 16.195 11.179 16.039 11.128 16.195 10.965 16.195 11.097 16.291 11.047 16.446 11.179 16.35 11.311 16.446 11.26 16.291 11.392 16.195 11.229 16.195",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.578 16.678 10.535 16.548 10.492 16.678 10.357 16.678 10.467 16.759 10.425 16.887 10.536 16.807 10.646 16.887 10.604 16.758 10.713 16.678 10.578 16.678",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.716 15.91 11.692 15.835 11.668 15.91 11.591 15.91 11.654 15.955 11.63 16.029 11.693 15.984 11.756 16.029 11.732 15.955 11.795 15.91 11.716 15.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.314 16.728 12.271 16.598 12.229 16.728 12.093 16.728 12.203 16.808 12.161 16.937 12.271 16.858 12.381 16.937 12.339 16.809 12.45 16.728 12.314 16.728",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.148 17.261 12.115 17.158 12.081 17.261 11.971 17.261 12.06 17.326 12.026 17.428 12.115 17.364 12.203 17.428 12.169 17.325 12.257 17.261 12.148 17.261",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.679 13.302 16.629 13.147 16.578 13.302 16.414 13.302 16.547 13.398 16.497 13.554 16.629 13.458 16.761 13.554 16.71 13.397 16.842 13.302 16.679 13.302",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.597 16.869 18.547 17.025 18.679 16.93 18.811 17.025 18.76 16.869 18.892 16.773 18.729 16.773 18.679 16.618 18.628 16.773 18.465 16.773 18.597 16.869",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.462 16.91 19.55 16.846 19.441 16.846 19.408 16.743 19.374 16.846 19.264 16.846 19.352 16.91 19.318 17.014 19.407 16.95 19.496 17.014 19.462 16.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.935 17.249 18.893 17.12 18.851 17.249 18.715 17.249 18.825 17.329 18.782 17.459 18.892 17.379 19.003 17.459 18.96 17.33 19.071 17.249 18.935 17.249",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.628 18.22 17.585 18.35 17.45 18.35 17.56 18.431 17.518 18.559 17.629 18.478 17.739 18.559 17.697 18.43 17.806 18.35 17.671 18.35 17.628 18.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.654 18.889 17.621 18.785 17.587 18.889 17.478 18.889 17.566 18.953 17.533 19.057 17.621 18.993 17.709 19.057 17.676 18.954 17.764 18.889 17.654 18.889",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.184 17.947 18.15 17.842 18.116 17.947 18.007 17.947 18.095 18.011 18.062 18.114 18.15 18.05 18.238 18.114 18.205 18.011 18.292 17.947 18.184 17.947",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.613 17.67 18.571 17.541 18.529 17.67 18.393 17.67 18.504 17.751 18.461 17.88 18.572 17.801 18.682 17.88 18.639 17.75 18.749 17.67 18.613 17.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.552 17.911 17.518 18.015 17.607 17.95 17.695 18.015 17.661 17.911 17.75 17.846 17.64 17.846 17.607 17.743 17.573 17.846 17.464 17.846 17.552 17.911",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.043 15.157 13 15.027 12.958 15.157 12.822 15.157 12.932 15.237 12.89 15.366 13 15.286 13.11 15.366 13.068 15.238 13.179 15.157 13.043 15.157",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.429 14.793 16.517 14.858 16.483 14.754 16.571 14.689 16.462 14.689 16.429 14.586 16.395 14.689 16.285 14.689 16.374 14.754 16.341 14.858 16.429 14.793",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.051 17.288 15 17.132 14.949 17.288 14.786 17.288 14.918 17.384 14.868 17.539 15 17.443 15.132 17.539 15.082 17.384 15.214 17.288 15.051 17.288",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.649 16.257 15.607 16.127 15.564 16.257 15.428 16.257 15.539 16.337 15.497 16.466 15.607 16.385 15.717 16.466 15.675 16.337 15.785 16.257 15.649 16.257",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.932 15.865 14.889 15.994 15 15.915 15.11 15.994 15.068 15.866 15.178 15.785 15.043 15.785 15 15.655 14.957 15.785 14.822 15.785 14.932 15.865",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.505 16.268 14.471 16.164 14.438 16.268 14.329 16.268 14.417 16.332 14.383 16.436 14.471 16.372 14.559 16.436 14.526 16.332 14.614 16.268 14.505 16.268",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.736 16.72 14.798 16.765 14.774 16.69 14.837 16.645 14.759 16.645 14.736 16.571 14.712 16.645 14.634 16.645 14.697 16.69 14.673 16.765 14.736 16.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.614 18.478 16.571 18.349 16.529 18.478 16.393 18.478 16.503 18.558 16.461 18.687 16.571 18.607 16.681 18.687 16.639 18.559 16.75 18.478 16.614 18.478",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.055 18.025 17.021 17.921 16.988 18.025 16.879 18.025 16.967 18.089 16.933 18.193 17.021 18.129 17.109 18.193 17.076 18.089 17.164 18.025 17.055 18.025",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.191 17.897 16.157 17.793 16.124 17.897 16.015 17.897 16.103 17.961 16.069 18.065 16.157 18.001 16.245 18.065 16.212 17.961 16.3 17.897 16.191 17.897",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.943 17.716 12.893 17.56 12.842 17.716 12.678 17.716 12.811 17.812 12.76 17.967 12.893 17.872 13.025 17.967 12.974 17.812 13.107 17.716 12.943 17.716",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.017 19.084 15 19.032 14.983 19.084 14.928 19.084 14.973 19.116 14.956 19.168 15 19.136 15.044 19.168 15.027 19.116 15.071 19.084 15.017 19.084",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/BR.628035909dd79abe2904eaf23eaed161.svg";
export { ForwardRef as ReactComponent };